import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness.js";

const tabelaSigefSimplificada = async function(ficha, node, callback, dicionario){

  let valores = await IndicadorRealBusiness.listarSigef(ficha.id).catch(e => []);
console.log(valores)
  if(node.params.lista !== undefined){
    dicionario.tabelaSigef = valores;
    return await callback(node.children, dicionario);
  }

  let itens = valores.map(e => {
    return `
          <tr>
              <td align="center">${e.vertice}</td>
              <td align="center">${e.destino}</td>
              <td align="center">${e.longitudeDms}</td>
              <td align="center">${e.latitudeDms}</td>
              <td align="center">${e.tipo}</td>
              <td align="center">${e.lado}</td>
              <td align="center">${e.confrontante}</td>
          </tr>
      `;
  });

  let output = `
    <table class="tabela-sigef">
        <tr>
            <th colspan="8" align="center">Segue abaixo a tabela do Georreferenciamento, certificada pelo INCRA:</th>
        </tr>
        <tr>
            <th align="center" style="white-space: nowrap">Do Vértice</th>
            <th align="center" style="white-space: nowrap">Ao Vértice</th>
            <th align="center" style="white-space: nowrap">Logitude</th>
            <th align="center" style="white-space: nowrap">Latitude</th>
            <th align="center" style="white-space: nowrap">Tipo</th>
            <th align="center" style="white-space: nowrap">Lado</th>
            <th align="center" style="white-space: nowrap">Confrontante</th>
        </tr>
        ${itens.join('')}
    </table>
  `;

  return output;

};

export default tabelaSigefSimplificada;

